import React, { useEffect, useRef, useState } from 'react';
import AppStrings from '../../config/appstring';
import DiscountType from '../../Class/DiscountTypes';
import BusSelect from '../../Class/BusList';
import FeesPrint from '../Print/FeesPrint';

function TransportFeesForm({ onClose, studentData }) {
  const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
  const [feeDetails, setFeeDetails] = useState([]);
  const [discountModalIndex, setDiscountModalIndex] = useState(null);
  const [tempDiscount, setTempDiscount] = useState('');
  const [tempDiscountType, setTempDiscountType] = useState('');
  const [tempDiscountRemarks, setTempDiscountRemarks] = useState('');
  const discountInputRef = useRef(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [printRefNo, setPrintRefNo] = useState(null);

    const [formData, setFormData] = useState({
      CLASS: '',
      SECTION: '',
      DOADM: new Date().toISOString().split('T')[0],
      SHIFT: ''
    });
  

  const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleOpenDiscountModal = (index) => {
    setTempDiscount(feeDetails[index].discount || '');
    setTempDiscountType(feeDetails[index].discountType || '');
    setTempDiscountRemarks(feeDetails[index].discountRemark || '');
    setDiscountModalIndex(index);
  };

const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleShiftChange = (e) => {
    const selectedShift = e.target.value;
    setFormData(prev => ({
      ...prev,
      SHIFT: selectedShift,
    }));
    fetchFeeDetails(formData.PLACE, selectedShift);
  };

  const handleSaveDiscount = () => {
     if (discountModalIndex !== null) {
      const idx = discountModalIndex;
      const oldFee = feeDetails[idx];
      const oldFeeAmount = parseFloat(oldFee.FEES) || 0;
      const oldDiscount = parseFloat(oldFee.discount) || 0;
      const oldPayable = oldFeeAmount - oldDiscount;
      const oldPaid = parseFloat(oldFee.current) || 0;

      const newDiscount = parseFloat(tempDiscount) || 0;
      const newPayable = oldFeeAmount - newDiscount;

      const updated = [...feeDetails];
      updated[idx].discount = tempDiscount;
      updated[idx].discountType = tempDiscountType;
      updated[idx].discountRemark = tempDiscountRemarks;

      // ✅ Update paid amount if user had paid full earlier
      if (oldPaid === oldPayable) {
        updated[idx].current = newPayable.toFixed(2);
      }

      setFeeDetails(updated);
      setDiscountModalIndex(null);
    }
  };

  const handleCancelDiscount = () => {
    setDiscountModalIndex(null);
  };


  const fetchFeeDetails = async (place, shift) => {
    if (!place || !shift) return;

    const url = AppStrings.VanFeesDetails + `?TYPE=${encodeURIComponent(shift)}&PLACE=${encodeURIComponent(place)}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      const feeArray = Array.isArray(data.data) ? data.data : data?.data?.result || [];

      const formatted = feeArray.map(item => ({
        ...item,
        current: '',
        discount: '',
        discountType: '',
        discountRemark: ''
      }));
      console.log('lllllllllllllllll',formatted)

      setFeeDetails(formatted);
    } catch (error) {
      console.error('Error fetching fee data:', error);
      setFeeDetails([]);
    }
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);

  const handleYesNo = () => {
  setShowConfirmModal(true);
};

  const handleSubmit = async () => {
    const payload = {
      student: {
        id:studentData.id,
        admissionDate: admissionDate,
        type: studentData.addfees,
         place: formData.PLACE,
         pickuptype: formData.SHIFT,
      },
      fees: feeDetails.filter(({ current, discount }) => {
        const paid = parseFloat(current) || 0;
        const off = parseFloat(discount) || 0;
        return paid + off > 0;
      }).map(({ LIST, FEES, current, discount, discountType, discountRemark }) => ({
        LIST, FEES, current, discount, discountType, discountRemark,
      }))
    };

    try {
      const res = await fetch(AppStrings.BusFeesEntry, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
      setPrintRefNo(result.data[0].REFNO);
      alert(result.message || "Data saved successfully!");
      // handleCancel();
      // onClose();
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to save data.");
    }
  };

  const handleCancel = () => {
    setFeeDetails([]);
  };

  useEffect(() => {
    handlePayClick();
  }, []);

  useEffect(() => {
    if (discountModalIndex !== null && discountInputRef.current) {
      discountInputRef.current.focus();
    }
  }, [discountModalIndex]);

 

  const handlePayClick = async () => {
    const feeType = studentData.addfees;
    const className = studentData.class;
    const type = 'N';
    const AdmissionID=studentData.id

    if (!feeType || !className) {
      alert('Missing class or fee type for this student.');
      return;
    }

    //setSelectedRow(row);
    setFormData({ PLACE: '', SHIFT: '' });
    setFeeDetails([]);

    
console.log(AdmissionID,'45555');

      const url = AppStrings.BusDetails+`?studentid=${AdmissionID}`;

      try {
        const response = await fetch(url);
        const data = await response.json();
console.log(data,'kkkkkk');
        const feeArray = Array.isArray(data.data) ? data.data : data.data?.data.data?.result || [];
        console.log(feeArray,'feaaaaaaaaeeeeeeeeeee');
        const formatted = feeArray.map(item => ({
          ...item,
          current: '',
          discount: ''
        }));

        setFeeDetails(formatted);
        console.log(feeDetails,'feeeeeeeeeeee');
      } catch (error) {
        console.error('Error fetching fee data:', error);
        setFeeDetails([]);
      }
    
  };


  console.log('feeDetails:', feeDetails);  // For debugging

  return (
    <div style={modalOverlayStyle}>
      <div style={modalStyle}>
        {studentData && (
          <div style={{ marginBottom: '15px', textAlign: 'center' }}>
            <strong>Student:</strong> {studentData.name} | <strong>Id:</strong> {studentData.id}
          </div>
        )}

        <div className="row">
          <div className="col-25">
          <BusSelect
  value={formData.PLACE || ''}
  onChange={(e) => handleFormChange({ target: { name: 'PLACE', value: e.target.value } })}
/>
          </div>
          <div className="col-75">
            <div className="coolinput">
              <input
                required
                type="date"
                name="DOADM"
                autoComplete="off"
                className="input"
                value={admissionDate}
                onChange={(e) => setAdmissionDate(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-25">
            <label style={{ marginRight: '10px' }}>
              <input
                type="radio"
                name="SHIFT"
                value="P"
                checked={formData.SHIFT === "P"}
                onChange={handleShiftChange}
              />
              Full Term
            </label>
            <label>
              <input
                type="radio"
                name="SHIFT"
                value="H"
                checked={formData.SHIFT === "H"}
                onChange={handleShiftChange}
              />
              Half Term
            </label>
          </div>
        </div>

        {/* Safe check for feeDetails length and PLACE */}
        {feeDetails.length > 0 && feeDetails[0]?.PLACE && (
          <div style={{ margin: '10px 0', fontWeight: 'bold', fontSize: '16px', color: '#333' }}>
            Place: {feeDetails[0].PLACE}
          </div>
        )}

        {feeDetails.length > 0 ? (
          <table style={{ width: '100%', marginTop: '10px', border: '1px solid #ccc', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
            <thead>
              <tr>
                <th style={{ ...headerCellStyle, width: '20px' }}></th>
                <th style={headerCellStyle}>Fee Type</th>
                <th style={headerCellStyle}>Fee Amount</th>
                <th style={headerCellStyle}>Discount Type</th>
                <th style={headerCellStyle}>Discount</th>
                <th style={headerCellStyle}>Paid</th>
                <th style={headerCellStyle}>Remark</th>
              </tr>
            </thead>
            <tbody>
              {feeDetails.map((fee, idx) => {
                const feeAmount = parseFloat(fee.FEES) || 0;
                const discount = parseFloat(fee.discount) || 0;
                const payable = feeAmount - discount;

                return (
                  <tr key={idx}>
                     <td style={cellStyle}>
                        <input
                          type="checkbox"
                          checked={parseFloat(fee.current || 0) === payable}
                          onChange={(e) => {
                            const paidAmount = e.target.checked ? payable.toFixed(2) : '';
                            handleInputChange(idx, 'current', paidAmount);
                          }}
                        />
                      </td>
                    <td style={cellStyle}>{fee.LIST || '-'}</td>
                    <td style={cellStyle}>{fee.FEES || '-'}</td>
                    <td style={cellStyle}>{fee.discountType || '-'}</td>
                    <td style={cellStyle}>
                      <div className="coolinput">
                        <button
                          onClick={() => handleOpenDiscountModal(idx)}
                          className="input"
                          style={{
                            width: '100%',
                            padding: '8px',
                            textAlign: 'left',
                            backgroundColor: '#f9f9f9',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            color: 'Black'
                          }}
                        >
                          <span role="img" aria-label="discount">🏷️</span>
                          ₹ {fee.discount ? fee.discount : ''}
                        </button>
                      </div>
                    </td>
                    <td style={cellStyle}>
                      <div className="coolinput">
                        <input
                          type="text"
                          placeholder="Paid Amount"
                          value={fee.current}
                          onChange={(e) => handleInputChange(idx, 'current', e.target.value)}
                          className="input PayInPut"
                        />
                      </div>
                      <div style={{ fontSize: '0.8em', color: '#555' }}>
                        Payable: ₹{payable.toFixed(2)}
                      </div>
                    </td>
              <td style={cellStyle}>
  {(fee.discountRemark || '-').toUpperCase()}
</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p>No fee data available.</p>
        )}

        <div style={{ marginTop: '15px', textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>
          Total Paid Amount: ₹{totalPaid.toFixed(2)}
        </div>

        <button onClick={handleYesNo} style={{ marginTop: '15px' }}>Save</button>
        <button onClick={onClose} style={{ marginTop: '15px', marginLeft: '10px' }}>Close</button>

        {discountModalIndex !== null && (
          <div style={modalOverlayStyle}>
            <div style={{ ...modalStyle, width: '300px', textAlign: 'center' }}>
              <h3>Discount Type</h3>
              <DiscountType
                value={tempDiscountType}
                onChange={(val) => setTempDiscountType(val)}
              />

              <h3>Enter Discount</h3>
              <div className="coolinput">
                <input
                  ref={discountInputRef}
                  type="text"
                  placeholder="Discount Amount"
                  className="input PayInPut"
                  value={tempDiscount}
                  onChange={(e) => setTempDiscount(e.target.value)}
                />
              </div>

              <h3>Remarks</h3>
              <div className="coolinput">
                <input
                  type="text"
                  placeholder="Remarks"
                  className="input PayInPut"
                  value={tempDiscountRemarks}
                  onChange={(e) => setTempDiscountRemarks(e.target.value)}
                />
              </div>

              <div style={{ marginTop: '15px' }}>
                <button onClick={handleSaveDiscount}>Save</button>
                <button onClick={handleCancelDiscount} style={{ marginLeft: '10px' }}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {showConfirmModal && (
  <div style={modalOverlayStyle}>
    <div style={{ ...modalStyle, width: '300px', textAlign: 'center' }}>
      <h3>Confirm Save</h3>
      <p>Are you sure you want to save this data?</p>
      <div style={{ marginTop: '15px' }}>
        <button
          onClick={() => {
            setShowConfirmModal(false);
            handleSubmit(); // ✅ proceed with actual submission
          }}
        >
          Yes
        </button>
        <button
          onClick={() => setShowConfirmModal(false)}
          style={{ marginLeft: '10px' }}
        >
          No
        </button>
      </div>
    </div>
  </div>
)}

{printRefNo && (
  <div style={modalOverlayStyle}>
    <div style={modalStyle}>
      <FeesPrint
              RefNo={printRefNo}
              onClose={() => {
                setPrintRefNo(null); // ✅ close the print modal
                onClose();           // ✅ now close the full form
              }}
            />
    </div>
  </div>
)}
      </div>
    </div>
  );
}

export default TransportFeesForm;

// === Styles ===

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '750px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
};

const headerCellStyle = {
  padding: '8px',
  backgroundColor: '#f2f2f2',
};

const cellStyle = {
  padding: '4px',
  fontSize: '13px',
};
